import { formatMoney } from '../utils/formatMoney';

interface MoneyCellProps {
  value: number | undefined | null;
  showCurrency?: boolean;
  className?: string;
}

export default function MoneyCell({ value, showCurrency = true, className = '' }: MoneyCellProps) {
  return (
    <span className={`num ${className}`}>
      {formatMoney(value, showCurrency)}
    </span>
  );
}
